export default function Footer()
{
    return (
        <div className="footer">
            <div>
                <span>&copy; 2025 Seow Sin Kiat - v2.1.0</span>
            </div>
        </div>
    );
}